import React from "react";
import { Link } from "react-router-dom";
import {
  Building2,
  Scroll,
  FileSignature,
  Briefcase,
  Landmark,
  ShieldCheck,
  ArrowRight,
  CheckCircle2,
} from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const categories = [
  { key: "immobilier", icon: Building2 },
  { key: "successions", icon: Scroll },
  { key: "procurations", icon: FileSignature },
  { key: "societes", icon: Briefcase },
  { key: "garanties", icon: Landmark },
  { key: "certifications", icon: ShieldCheck },
];

export default function Services() {
  const { t } = useLang();

  return (
    <div>
      <section className="border-b border-border-light" data-testid="services-hero">
        <div className="container-notary py-20 md:py-24">
          <div className="overline mb-4">{t("services.eyebrow")}</div>
          <h1 className="text-4xl md:text-5xl font-serif text-charcoal max-w-3xl">
            {t("services.title")}
          </h1>
          <span className="divider-gold my-6 block" />
          <p className="text-lg text-charcoal-muted max-w-2xl">{t("services.subtitle")}</p>
        </div>
      </section>

      <section className="container-notary py-20 md:py-24">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-border-light border border-border-light">
          {categories.map(({ key, icon: Icon }) => (
            <article
              key={key}
              className="bg-surface p-8 md:p-10 flex flex-col gap-5"
              data-testid={`service-detail-${key}`}
            >
              <div className="flex items-center gap-4">
                <Icon className="w-8 h-8 text-gold" strokeWidth={1.2} />
                <h2 className="font-serif text-2xl md:text-3xl text-charcoal">
                  {t(`services.categories.${key}.title`)}
                </h2>
              </div>
              <p className="text-charcoal-muted leading-relaxed">
                {t(`services.categories.${key}.desc`)}
              </p>
              <ul className="grid grid-cols-1 md:grid-cols-2 gap-y-2 gap-x-6 mt-2">
                {(t(`services.categories.${key}.items`) || []).map((it) => (
                  <li key={it} className="flex items-start gap-2 text-sm text-charcoal">
                    <CheckCircle2 className="w-4 h-4 text-gold mt-[3px] shrink-0" />
                    <span>{it}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-auto pt-6 flex flex-wrap gap-3">
                <Link
                  to={`/documents?cat=${key}`}
                  className="btn-outline-dark"
                  data-testid={`service-${key}-docs`}
                >
                  {t("services.cta1")}
                  <ArrowRight className="w-4 h-4 rtl-flip" />
                </Link>
                <Link
                  to="/rendez-vous"
                  className="btn-ghost"
                  data-testid={`service-${key}-appointment`}
                >
                  {t("services.cta2")}
                  <ArrowRight className="w-4 h-4 rtl-flip" />
                </Link>
              </div>
            </article>
          ))}
        </div>
      </section>
    </div>
  );
}
